import {getAccessToken } from '../authService'

export const API_BASE_URL =
    window.location.hostname === "localhost"
        ? "https://localhost:7213/api"
        : "/api"; 

async function handleResponse<T>(response: Response): Promise<T> {
    const contentType = response.headers.get("content-type") || "";
    const text = await response.text();

    if (!response.ok) {
        if (text) {
            try {
                if (contentType.includes("application/json")) {
                    const parsed = JSON.parse(text);
                    throw new Error(`API Error: ${response.status} ${JSON.stringify(parsed)}`);
                }
                throw new Error(`API Error: ${response.status} ${text}`);
            } catch (err) {
                // If JSON.parse fails, fall back to raw text
                throw new Error(`API Error: ${response.status} ${text}`);
            }
        }
        throw new Error(`API Error: ${response.status}`);
    }

    if (!text) return ({} as T);

    if (contentType.includes("application/json")) {
        return JSON.parse(text) as T;
    }

    // For non-JSON successful responses return raw text (caller may cast)
    return (text as unknown) as T;
}

export async function apiGet<T>(url: string): Promise<T> {
    const token = await getAccessToken();

    const response = await fetch(`${API_BASE_URL}${url}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    });

    return handleResponse<T>(response);
}

export async function apiPost<T>(url: string, body: any): Promise<T> {
    const token = await getAccessToken();

    const response = await fetch(`${API_BASE_URL}${url}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
    });

    return handleResponse<T>(response);
}

export async function apiPut<T>(url: string, body: any): Promise<T> {
    const token = await getAccessToken();

    const response = await fetch(`${API_BASE_URL}${url}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
    });

    return handleResponse<T>(response);
}

export async function apiDelete<T>(url: string): Promise<T> {
    const token = await getAccessToken();

    const response = await fetch(`${API_BASE_URL}${url}`, {
        method: "DELETE",
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });

    return handleResponse<T>(response);
}